import { render, staticRenderFns } from "./footmark.vue?vue&type=template&id=07483066&scoped=true"
import script from "./footmark.vue?vue&type=script&lang=js"
export * from "./footmark.vue?vue&type=script&lang=js"
import style0 from "./footmark.vue?vue&type=style&index=0&id=07483066&prod&lang=scss&scoped=true"
import style1 from "./footmark.vue?vue&type=style&index=1&id=07483066&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07483066",
  null
  
)

export default component.exports